import React from 'react';

const Archive: React.FC = () => {
    return (
        <h3 style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto', color: '#F7F9F9' }}>Archive Page</h3>
    );
};

export default Archive;